import { Component, effect, inject, input } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { UserContext } from '../../shell/user-context';
import { MainFooter } from '../layout/main-footer/main-footer';
import { MainHeader } from '../layout/main-header/main-header';
import { MainNav } from '../layout/main-nav/main-nav';
import { SidebarNavigationState } from '../layout/sidebar-navigation-state';
import { FatalErrorListener } from '../shell-diagnostics/fatal-error-listener';
import { FatalErrorOverlay } from '../shell-diagnostics/fatal-error-overlay/fatal-error-overlay';
import { TranslationStatusBanner } from '../shell-diagnostics/translation-status-banner/translation-status-banner';

@Component({
  selector: 'ima-root',
  imports: [
    RouterOutlet,
    MainHeader,
    MainNav,
    MainFooter,
    TranslationStatusBanner,
    FatalErrorOverlay,
  ],
  templateUrl: './app-root.html',
  styleUrl: './app-root.scss',
})
export class AppRoot {
  readonly activeUser = input('Anonymous User');

  // Off by default so the sidebar's collapse button keeps hiding the nav
  // entirely, same as before. Flip to true to switch MainNav's collapse
  // presentation to its icon-only rail instead (see MainNav's own doc
  // comment on `collapseTextOnly`).
  protected readonly collapseNavTextOnly = true;

  protected readonly sidebarState = inject(SidebarNavigationState);
  private readonly userContext = inject(UserContext);

  constructor() {
    // Activates the standalone-only runtime-failure listener (a no-op in
    // federated mode — see FatalErrorListener's own doc comment). Injecting
    // it is enough: @Service() means this instantiates it once,
    // running its constructor.
    inject(FatalErrorListener);

    // Descendants share the user context supplied by the Web Component host.
    effect(() => {
      this.userContext.activeUser.set(this.activeUser());
    });
  }
}
